import { useEffect } from "react";
import { useRouter } from "next/router";
import { getCookie, setCookie } from "cookies-next";
import { LOCALES_COOKIE_NAME } from "../utils/locales";

const ENABLE_LOCALE_FILTER_CHECK = false; // temporary disabled

export const useLocaleFilter = () => {
  if (typeof window === 'undefined') {
    return;
  }
  const router = useRouter();

  const checkCookies = async () => {
    const locales = getCookie(LOCALES_COOKIE_NAME);

    // записываем в cookies новые значения фильтра района
    // будет использоваться если перешли по прямой ссылке с выбранными районами
    if (locales !== router.query.locales) {
      setCookie(LOCALES_COOKIE_NAME, router.query.locales);
    }
  }

  if (ENABLE_LOCALE_FILTER_CHECK) {
    useEffect(() => {
      setTimeout(() => checkCookies());
    }, [router.query]);
  }
}
